import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import AnalyticsManager from "./AnalyticsManager";

const getPageName = (pathname: string): string => {
    const segments = pathname.split('/').filter(Boolean);
    if (segments.length === 0) return "Home";

    const routeMap: Record<string, string> = {
        'option-chain': 'Option Chain',
        'strategy-builder': 'Strategy Builder',
        'multi-strike-chart': 'Multi Strike Chart',
        'screener': 'Screener',
        'fii-dii': 'FII DII',
        'chart': 'Chart',
        'symbol': 'Symbol',
        'spread': 'Spread',
        'reports': 'Reports',
        'profile': 'Profile',
        'dashboard': 'Dashboard',
        'automation': 'Automation',
        'simulator': 'Simulator',
        'trading-account': 'Trading Account',
        'scalper': 'Scalper',
        'admin': 'Admin',
    };

    const basePath = segments[0];
    return routeMap[basePath] || basePath.charAt(0).toUpperCase() + basePath.slice(1);
};

export const usePageTimeSpent = () => {
    const location = useLocation();
    const minutesRef = useRef(0);
    const intervalRef = useRef<NodeJS.Timeout | null>(null);
    const pathRef = useRef(location.pathname);

    const startTimer = () => {
        if (intervalRef.current) return;

        minutesRef.current = 0;

        intervalRef.current = setInterval(() => {
            minutesRef.current += 1;

            const currentPath = pathRef.current;
            const pageName = getPageName(currentPath);

            AnalyticsManager.logEvent(`${pageName} Page Time Spent`, {
                page_name: currentPath,
                time_spent_minutes: `${minutesRef.current} min`,
            });
        }, 60000);
    };

    const stopTimer = () => {
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    };


    useEffect(() => {
        stopTimer();
        pathRef.current = location.pathname;
        startTimer();

        return () => {
            stopTimer();
        };
    }, [location.pathname]);


    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.hidden) {
                stopTimer();
            } else {
                startTimer();
            }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);
};